import _template from 'lodash/template'
import _get from 'lodash/get'
import validationRules from './config'

const flatten = (source, flatKey) => {
  let newSource = {}

  Object.keys(source).forEach(key => {
    let value = source[key]
    let currentFlatKey = flatKey ? `${flatKey}.${key}` : key

    if (value && typeof value === 'object' && !Array.isArray(value) && value !== null) {
      newSource = Object.assign(newSource, flatten(value, currentFlatKey))
    } else {
      newSource[currentFlatKey] = value
    }
  })

  return newSource
}

const defaultOptions = {}

function renderMsg (msg, args) {
  msg = args.msg || msg

  if (typeof msg === 'function') {
    msg = msg.call(this)
  }

  return _template(msg, {interpolate: /{{([\s\S]+?)}}/g})(args)
}

function valid (path) {
  let validation = this.$options.validation
  let validations = _get(validation.data, path, validation.data)

  Object.entries(validations).forEach(([dataName, dataValidations]) => {
    let dataPath = path ? `${path}.${dataName}` : dataName
    let msgValidations = _get(validation.msg, path)
    validate.call(this, dataPath, _get(this, dataPath), {msgValidations, dataValidations})
  })
  return !this.$options._validationErrors
}

function error (dataName) {
  const errors = this.$options._validationErrors || {}
  let error = errors[dataName]
  return error ? error[0] : null
}

function validate (path, value, {msgValidations, dataValidations}) {
  let errors = []
  if (dataValidations.if) {
    dataValidations.if.call(this, dataValidations)
  }
  if (!value && !dataValidations.required) {
    if (this.$options._validationErrors && this.$options._validationErrors[path]) {
      delete this.$options._validationErrors[path]
    }
    return
  }
  if (typeof dataValidations === 'string') {
    return
  }
  if (typeof msgValidations !== 'object') {
    msgValidations = {}
  }

  Object.entries(dataValidations).forEach(([name, args]) => {
    if (args !== false) {
      let validation = validationRules[name]
      let msgArgs = {msg: msgValidations[name]}
      let dataArgs = dataValidations[name]
      if (typeof dataArgs === 'object') {
        Object.assign(msgArgs, dataValidations[name])
      }
      msgArgs.field = msgArgs.field || path
      if (validation) {
        let {valid, msg} = validation(value, args)
        if (!valid) {
          errors.push(renderMsg.call(this, msg, msgArgs))
        }
      }
    }
  })

  if (errors.length) {
    this.$options._validationErrors = this.$options._validationErrors || {}
    this.$options._validationErrors[path] = errors
  } else if (this.$options._validationErrors) {
    if (this.$options._validationErrors[path]) {
      delete this.$options._validationErrors[path]
    }

    if (Object.keys(this.$options._validationErrors).length === 0) {
      this.$options._validationErrors = null
    }
  }
}

const install = (Vue, options = {}) => {
  options = {...defaultOptions, ...options}

  Vue.mixin({
    created () {
      const validation = this.$options.validation
      const $this = this
      if (validation && validation.data) {
        Object.entries(flatten($this.$data)).forEach(([path, _]) => {
          let dataValidations = _get(validation.data, path)
          let msgValidations = _get(validation.msg, path)
          if (dataValidations) {
            $this.$watch(path, value => {
              validate.call($this, path, value, {msgValidations, dataValidations})
            })
          }
        })
      }
    },
    provide () {
      return {$validation: this.$validation}
    },
    computed: {
      $validation () {
        if (this.$options.validation !== undefined) {
          return {
            submit: false,
            error: dataName => {
              return error.call(this, dataName)
            },
            errors: path => {
              return _get(this.$options._validationErrors, path, this.$options._validationErrors)
            },
            reset: callback => {
              this.$options._validationErrors = null
              this.$nextTick(() => {
                this.$options._validationErrors = null
                if (callback) {
                  callback.call(this)
                }
              })
              this.$root.$emit('showErr', false)
            },
            valid: dataName => {
              return valid.call(this, dataName)
            },
            validAll: arguPath => {
              let validation = this.$options.validation
              let $this = this
              if (validation && validation.data) {
                Object.entries(flatten($this.$data)).forEach(([path, _]) => {
                  let dataValidations = _get(validation.data, path)
                  let msgValidations = _get(validation.msg, path)
                  let value = _get(this._data, path)
                  if (dataValidations) {
                    validate.call($this, path, value, {msgValidations, dataValidations})
                  }
                })
              }
              this.$root.$emit('showErr', false)
              return this.$validation.errors()
            },
            options: {
              ...options,
              ...this.$options.validation
            }
          }
        } else {
          return undefined
        }
      }
    }
  })
}

export default {
  install,
  renderMsg,
  defaultOptions,
  version: '__VERSION__'
}
